import { Model } from '@/models/Model';
export class DeleteCurrentPLP extends Model {
    constructor() {
        super(...arguments);
        this.status = ['highlighted', 'busy', 'old'];
        this.$name = 'DeleteCurrentPLP';
        this.$endpoint = '/commands/delete-student-subjects';
        this.$fillable = ['school', 'status'];
    }
    set statusValue(status) {
        this.status = status;
    }
}
